import { render, staticRenderFns } from "./ProductPerformanceTable.vue?vue&type=template&id=29aabdc1"
import script from "./ProductPerformanceTable.vue?vue&type=script&lang=js"
export * from "./ProductPerformanceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports